import { render } from "./SuitLeak.vue?vue&type=template&id=a817cd64&scoped=true"
import script from "./SuitLeak.vue?vue&type=script&lang=js"
export * from "./SuitLeak.vue?vue&type=script&lang=js"

import "./SuitLeak.vue?vue&type=style&index=0&id=a817cd64&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a817cd64"]])

export default __exports__